import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-form-container",
  style: {"max-width":"700px"}
}
const _hoisted_2 = {
  ref: "modalContent",
  class: "w-full h-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "flex items-center modal-form-container-header-title" }, "3D모델 분석 상세 설명", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-cross" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal-form-container-content" }

import { storeToRefs } from "pinia";
import { CommonStore } from "../../store/common-store";

import { ref, computed, defineComponent, onMounted } from "vue";

import InstDesc1 from "./instructions/InstDesc1.vue";
import InstDesc2 from "./instructions/InstDesc2.vue";
import InstDesc3 from "./instructions/InstDesc3.vue";
import InstDesc4 from "./instructions/InstDesc4.vue";
import InstDesc5 from "./instructions/InstDesc5.vue";
import InstDesc6 from "./instructions/InstDesc6.vue";
import InstDesc7 from "./instructions/InstDesc7.vue";
import InstDesc8 from "./instructions/InstDesc8.vue";
import InstDesc9 from "./instructions/InstDesc9.vue";
import InstDesc10 from "./instructions/InstDesc10.vue";

const __default__ = defineComponent({
  name: "ModalClientSubmit",
  components: {
    InstDesc1,
    InstDesc2,
    InstDesc3,
    InstDesc4,
    InstDesc5,
    InstDesc6,
    InstDesc7,
    InstDesc8,
    InstDesc9,
    InstDesc10,
  },
  methods: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { cModalData } = storeToRefs(CommonStore());

const onClose = () => {
  CommonStore().closeModal();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", { class: "modal-form-container-header border-b border-line" }, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("button", { onClick: onClose }, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        ('loadFile' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc1, { key: 0 }))
          : _createCommentVNode("", true),
        ('normalSize' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc2, { key: 1 }))
          : _createCommentVNode("", true),
        ('overVolume' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc3, { key: 2 }))
          : _createCommentVNode("", true),
        ('checkModel' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc4, { key: 3 }))
          : _createCommentVNode("", true),
        ('waterproof' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc5, { key: 4 }))
          : _createCommentVNode("", true),
        ('multiBody' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc6, { key: 5 }))
          : _createCommentVNode("", true),
        ('buildSize' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc7, { key: 6 }))
          : _createCommentVNode("", true),
        ('thickness' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc8, { key: 7 }))
          : _createCommentVNode("", true),
        ('gap' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc9, { key: 8 }))
          : _createCommentVNode("", true),
        ('hollow' === _unref(cModalData))
          ? (_openBlock(), _createBlock(InstDesc10, { key: 9 }))
          : _createCommentVNode("", true)
      ])
    ], 512)
  ]))
}
}

})